import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/mobile', pathMatch: 'full' },
  {
    path: 'mobile',
    loadChildren: () => import('./mobile/routes').then((m) => m.MOBILE_ROUTES),
  },
  {
    path: '**',
    loadChildren: () => import('./features/page-not-found/routes').then((m) => m.PAGE_NOT_FOUND_ROUTES),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
